import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox as MuiCheckbox } from '@material-ui/core';

const Checkbox = ({ value, ...rest }) => {
  return (
    <MuiCheckbox value={value} {...rest} />
  )
}

Checkbox.propTypes = {
  value: PropTypes.string.isRequired,
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/base/Checkbox/Checkbox.js